import { makeEntry } from './search-entry'
import { kindFor } from './kinds'

// The admin's NodeSearchSource: search entries from the list a page already
// loaded (content's rights-filtered /node-course, /node-template or
// /node-library rows: id, parentID, name, datatype, updatedAt, ...).
//
//   * Only the area's datatypes (`kinds`) are entries.
//   * The breadcrumb is the ancestors' names, root first, by parentID.
//   * A row whose parent chain doesn't reach a root (a live course under a
//     deleted folder) is left out, as content's hierarchy CTE and browsing
//     leave it out.
//   * updatedAt: content's time; Go's zero time ("0001-01-01T00:00:00Z", a
//     list that doesn't carry it) is none.
const MAX_DEPTH = 32

export const timeOf = value => {
  if (!value) return null
  const ms = typeof value === 'number' ? value : Date.parse(value)
  if (!isFinite(ms)) return null
  // Go's zero time and anything before 1971: none.
  if (ms < 31536000000) return null
  return ms
}

export const buildCorpus = (items, kinds) => {
  const rows = Array.isArray(items) ? items : []
  const byID = new Map()
  for (const row of rows) if (row && row.id !== undefined && row.id !== null) byID.set(row.id, row)

  const entries = []
  for (const row of rows) {
    if (!row || !kinds[(row.datatype || '').toUpperCase()]) continue

    const labels = []
    const ids = []
    let cursor = row.parentID
    let depth = 0
    let reachesRoot = true
    while (cursor !== null && cursor !== undefined && cursor !== 0) {
      const parent = byID.get(cursor)
      if (!parent || ++depth > MAX_DEPTH) {
        reachesRoot = false
        break
      }
      labels.push(parent.name || '')
      ids.push(parent.id)
      cursor = parent.parentID
    }
    if (!reachesRoot) continue
    labels.reverse()
    ids.reverse()

    const kind = kindFor(kinds, row.datatype)
    entries.push(
      makeEntry({
        id: row.id,
        name: row.name || '',
        pathLabels: labels,
        pathIds: ids,
        kind: kind.kind,
        isVideo: !!kind.video,
        updatedAt: timeOf(row.updatedAt),
        node: row
      })
    )
  }
  return entries
}
